import ApiService from "@/core/services/api.service";
import { STATUS_CODE } from "@/core/config/constant";
import { SET_ERROR } from "@/core/services/store/auth.module";
// mutation types
export const SET_LIST_NOTIFICATION = "setListNotification";
export const SET_LIST_NOTICE_USER = "setListNoticeUser";
export const LIST_NOTIFICATION = "listNotification";
export const NOTICE_USER_LIST = "listNoticeUser";
export const GET_LIST_NOTIFICATION = "getListNotification";
export const GET_LIST_NOTICE_USER = "getListNoticeUser";
const { SUCCESS, BAD_REQUEST } = STATUS_CODE;
export const SET_STATUS = "SetStatus"
export const SET_ERROR_MESSAGE = "SetErrorMessage"


const state = {
    listNotification: [],
    listNoticeUser: [],
    errors: null,
    status: null
};

const getters = {
    getListNotification: state => state.listNotification,
    getListNoticeUser: state => state.listNoticeUser,
};


const mutations = {
    [SET_LIST_NOTIFICATION](state, listNotification) {
        state.listNotification = listNotification;
    },
    [SET_LIST_NOTICE_USER](state, listNoticeUser) {
        state.listNoticeUser = listNoticeUser;
    },
    [SET_STATUS](state, code) {
        state.status = code;
    },
    [SET_ERROR_MESSAGE](state, errors) {
        state.errors = errors
    }
};


const actions = {
    async [LIST_NOTIFICATION](context) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        try {
            const response = await ApiService.get('notification/list')
            if (response.data.code == SUCCESS) {
                context.commit(SET_LIST_NOTIFICATION, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }

    },

    async [NOTICE_USER_LIST](context) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        try {
            const response = await ApiService.get('notice-user/list')
            if (response.data.code == SUCCESS) {
                context.commit(SET_LIST_NOTICE_USER, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }

    },
}



export default {
    state,
    actions,
    mutations,
    getters
};
